import { Link } from "react-router-dom";
import "../css/Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-inner">

        {/* BRAND */}
        <div className="footer-brand">
          <h2>NEO CAFÉ</h2>
          <p>
            A place for slow coffee, warm conversations,  
            and everyday rituals.
          </p>
        </div>

        {/* LINKS */}
        <div className="footer-links">
          <div>
            <h4>Explore</h4>
            <Link to="/">Home</Link>
            <Link to="/about">About</Link>
            <Link to="/menu">Menu</Link>
            <Link to="/gallery">Gallery</Link>
          </div>

          <div>
            <h4>Information</h4>
            <Link to="/reviews">Reviews</Link>
            <Link to="/faqs">FAQs</Link>
            <Link to="/contact">Contact</Link>
          </div>

          <div>
            <h4>Visit Us</h4>
            <span>Open Daily</span>
            <span>8:00 AM – 11:00 PM</span>
            <span>Downtown Café</span>
          </div>
        </div>

      </div>

      {/* BOTTOM BAR */}
      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} Neo Café</span>
        <span>Crafted with coffee & care</span>
      </div>
    </footer>
  );
};

export default Footer;
